import React from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { ClinicInfoPanel } from '../info/clinicInfoParts';
import ClinicSettingsFormFooter from '../subparts/ClinicSettingsFormFooter';

const HoursForm = ({ hours, onSave, isSaving = false }) => {
    const { control, register, handleSubmit } = useForm({
        defaultValues: { hours },
    });

    const { fields } = useFieldArray({
        control,
        name: 'hours',
    });

    const submit = (data) => {
        onSave(data.hours);
    };

    return (
        <ClinicInfoPanel title="Edit Weekly Schedule" icon="bi-pencil-square">
            <form onSubmit={handleSubmit(submit)}>
                <div className="clinic-settings-hours-list">
                    {fields.map((field, index) => (
                        <div key={field.id} className="clinic-settings-hours-item clinic-settings-hours-item--form">
                            <div className="clinic-settings-hours-item__day">{field.day}</div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Start"
                                {...register(`hours.${index}.start`)}
                            />
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="End"
                                {...register(`hours.${index}.end`)}
                            />
                            <select
                                className="form-select form-select-sm"
                                {...register(`hours.${index}.status`)}
                            >
                                <option value={true}>Open</option>
                                <option value={false}>Closed</option>
                            </select>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{ gridColumn: '2 / -1' }}
                                placeholder="Note (optional)"
                                {...register(`hours.${index}.note`)}
                            />
                        </div>
                    ))}
                </div>
                <ClinicSettingsFormFooter
                    isSaving={isSaving}
                />
            </form>
        </ClinicInfoPanel>
    );
};

export default HoursForm;
